export const questions = [
    {
        id: 1,
        question: "Web Developer",
        answer: "Lorem ipsum dolor sit amet consectetur, adipisicing elit. Eveniet unde ducimus delectus, ad hic tenetur animi, at, odio corporis sint commodi deserunt magni aliquid? Sit reprehenderit numquam perspiciatis? Illum, eius."
    },
    {
        id: 2,
        question: "Senior Digital Media Buyer",
        answer: "Lorem ipsum dolor sit amet consectetur, adipisicing elit. Eveniet unde ducimus delectus, ad hic tenetur animi, at, odio corporis sint commodi deserunt magni aliquid? Sit reprehenderit numquam perspiciatis? Illum, eius."
    },
]